angular.module('ihestiaCommonDirectives')
  .factory('OneListUploadDataContainer', ['UploadDataContainer', function(UploadDataContainer) {

    var OneListUploadDataContainer = function() {
      UploadDataContainer.apply(this, arguments);
      var self = this;
      this.files = {
        all: []
      };
      //@type  {scopeName => String}
      //WAITING - oczekiwanie na akcje
      //INFO -wysyłanie informacji o plikach
      //(w przypadku gdy flaga konfiguracji ustawiona 'firstCheckAllFiles' jest na false, powyższa faza nie występuje)
      //SENDING - faktyczne wysyłanie plików
      //VERIFY - sprawdza jakość pliku, np kod na polsie
      //ERROR - błąd przy sprawdzaniu typów atrybutów
      this.status = 'WAITING';
      this.callbacks.onErrorAttributes = null;

      this.configDefault = {
        //w zależności od tej flagi,
        //albo pliki wysyłane są po kolei
        //a jeśli na true
        //to najpierw wysyłamy informacje o plikach
        //a nastepnie jesli wszystkie pliki są poprawne wysyłamy faktyczne pliki
        firstCheckAllFiles: false,
        //Czy przed wysłaniem pliku wywołać usługę do sprawdzania
        checkFilesBeforeSend: true,
        autoUpload: false,
        keepBrokenFileInLibraryUploader: false,
        verifyForDocumentsTypes: [],
        doNotAddTokenId: false,
        oneFile: false //czy upload umozliwia tylko jeden plik
      };

      this.config = angular.copy(self.configDefault);

      //Uwaga funkcja powinna być wołana tylko na zamknięcie okna
      //ponieważ niszczy cały obiekt, więc też referencję
      this.clearUploadData = function() {
        delete self.files.all;
      };

      this.clearListFile = function() {
        angular.forEach(self.files.all, function(value, key) {
          delete self.files.all[key];
        });
      };

      this.areFileToSend = function() {
        var result = false;
        angular.forEach(self.files.all, function(fileModel) {
          if (fileModel.fileToSend()) {
            result = true;
          }

        });
        return result;
      };

      this.checkAllFilesSendWithoutErrors = function() {
        var result = true;
        angular.forEach(self.files.all, function(fileModel) {
          if (fileModel.hasError()) {
            result = false;
          }

        });
        return result;
      };

      this.checkInfoSendedAboutAllFiles = function() {
        var result = true;
        angular.forEach(self.files.all, function(fileModel) {
          if (fileModel.hasError()) {
            result = false;
          }

        });
        return result;
      };

      this.allFilesSended = function() {
        var result = true;
        angular.forEach(self.files.all, function(fileModel) {
          if (fileModel.fileToSend()) {
            result = false;
          }

        });
        return result;
      };

      this.setProcessedFile = function() {
        if (angular.isDefined(self.files.all[self.processedFileIndex])) {
          self.processedFile = self.files.all[self.processedFileIndex];
        }
      };

      this.getFirstIndexFileToSend = function() {
        var result = null;
        angular.forEach(self.files.all, function(fileModel, idx) {
          if (result === null && fileModel.fileToSend()) {
            result = idx;
          }

        });
        return result;
      };

      this.getProcessedFile = function() {
        return self.files.all[self.processedFileIndex];
      };

      this.getFileModelContainFile = function(file) {
        var fileModel = null;
        angular.forEach(self.files.all, function(val, i) {
          if (file.externalUploadFileId === val.file.externalUploadFileId) {
            fileModel = self.files.all[i];
          }
        });

        return fileModel;
      };

      /**
       * [getIndexFileModelContainFile wyszukuje index pliku na liście]
       * @param  {[File]} file     [plik którego szukamy]
       * @return {[int]}          index pliku
       */
      this.getIndexFileModelContainFile = function(file) {
        var index = null;
        angular.forEach(self.files.all, function(val, i) {
          if (file.externalUploadFileId === val.file.externalUploadFileId) {
            index = i;
          }
        });

        return index;
      };

      this.clearAllFiles = function() {
        self.files.all.splice(0, self.files.all.length);
      };

      this.areUploadedFilesWithoutErrors = function() {
        var result = false;
        angular.forEach(self.files.all, function(fileModel) {
          if (fileModel.fileIsUploaded()) {
            result = true;
          }

        });
        return result;
      };

      this.areUploadedFiles = function() {
        var result = false;
        angular.forEach(self.files.all, function(fileModel) {
          if (!fileModel.fileToSend()) {
            result = true;
          }

        });
        return result;
      };
    };

    return OneListUploadDataContainer;
  }]);